import React, { createContext, useContext } from "react";
import { Position } from "../../../../../domain/models/position-model";
import { StoreItem } from "../../../../../domain/models/storage-item";

type Context = {
  position: Position | null;
  setPosition: React.Dispatch<React.SetStateAction<Position | null>>;
  list: StoreItem[] | null;
  setList: React.Dispatch<React.SetStateAction<StoreItem[] | null>>;
};

export const InsertContext = createContext<Context>({
  position: null,
  setPosition: () => {},
  list: null,
  setList: () => {},
});

export const useAuditContext = () => {
  const context = useContext(InsertContext);
  if (!context) {
    throw new Error("useInsertContext must be used within a InsertProvider");
  }
  return context;
};
